<ng-container>
  <div class="m-1">
    <span class="align-middle"> <span class="text-uppercase" [innerHTML]="article?.ref | makeBoldPartOfText:searchText"></span>:
      <span [innerHTML]="article?.description | makeBoldPartOfText:searchText"></span></span>
  </div>
  <div class="d-flex flex-row m-1">
    <span class="badge p-2 badge-secondary">{{article?.widget?.width}} X {{article?.widget?.height}}</span>
  </div>
</ng-container>
